import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/account"); return; }

    const sessionId = match[1];
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        setUser(r.data.user);
        window.history.replaceState({}, "", "/account");
        toast.success(`Welcome, ${r.data.user.name?.split(" ")[0] || ""}`);
        navigate("/account", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/account", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-[50vh] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin h-8 w-8 border-4 border-brand-navy border-t-transparent rounded-full mx-auto" />
        <div className="mt-3 text-sm font-bold text-brand-navy">Signing you in...</div>
      </div>
    </div>
  );
}
